module.exports = __webpack_public_path__ + "img/qualityPlatform_数据来源真实.85297aca.png";